import styled, { css } from 'styled-components';

const MarkerContainer = styled.div`
  ${({ $background, $sizeIcon }) =>
    $background.indexOf('.svg') > -1
      ? css`
          width: ${$sizeIcon}px;
          height: ${$sizeIcon}px;
          border-radius: 0% 50% 50% 50%;
          background-image: url(/images/${$background});
          background-size: 100% 100%;
          transform: rotate(-135deg);
          transform-origin: top left;
        `
      : css`
          width: ${$sizeIcon}px;
          height: ${$sizeIcon}px;
          border-radius: 0% 50% 50% 50%;
          background: ${$background};
          transform: rotate(-135deg);
          transform-origin: top left;
        `}
  position: absolute;
  left: 50%;
  top: 50%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(135deg);
    ${({ $color }) =>
      $color &&
      css`
        color: ${$color};
      `}
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    pointer-events: none;
    display: ${({ $letter }) => ($letter ? 'block' : 'none')};
  }

  :hover {
    cursor: pointer;
  }
`;

export default MarkerContainer;
